import { connect } from 'react-redux'
import Profile from './profile'
import { withMe } from 'pobble-components/dist/pobble-user'
import {
  getUser,
  getFetchUserRequest
} from '../../../stores/user/user.selectors'
import { fetchUser } from '../../../stores/user/user.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { initFacebookSDK, initGoogleSDK } from 'pobble-components/dist/oauth'

const mapStateToProps = (state, { me, meRequest }) => {
  const fetchUserRequest = getFetchUserRequest(state)
  const user = getUser(state)
  return {
    pending: fetchUserRequest.pending,
    isStudent: !meRequest.pending && me && me.account.student_type,
    canUpdateEmail:
      user &&
      user.email_identity &&
      user.email_identity.policy &&
      user.email_identity.policy.can_update_email,
    canUpdatePassword:
      user &&
      user.email_identity &&
      user.email_identity.policy &&
      user.email_identity.policy.can_update_password
  }
}

const mapDispatchToProps = dispatch => ({
  onMount: () => {
    initFacebookSDK()
    initGoogleSDK()
    dispatch(fetchUser()).catch(errorHandler)
  }
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Profile)
)
